module.exports = __webpack_public_path__ + "img/Group 427320731@2x.317d7f7f.png";